export default {
    downloadUrl: { //下载地址
        ios: 'itms-services://?action=download-manifest&url=https://xdys.img.xm-dkjy.cn/statics/ios/manifest.plist',  //ios
        android: "https://xdys.app.xm-dkjy.cn/App/yhyg.apk"  //安卓下载地址
    },
    requestUrl: 'https://yhyg.xm-dkjy.cn/', //上线地址
}